import React, {
  useRef,
  forwardRef,
  useImperativeHandle
} from 'react';
import { Col } from 'react-bootstrap';
import { UseAlert } from 'hook/alert-hook';

// Interface do que será exposto via ref
export interface UploadFileRef {
  clearFileInput: () => void;
}

interface UploadFileProps {
  setNomeFile: React.Dispatch<React.SetStateAction<string>>;
  setContentFile: React.Dispatch<React.SetStateAction<File | undefined>>;
}

const MAX_FILE_SIZE = 130 * 1024 * 1024; // 130 MB

const UploadFile = forwardRef<UploadFileRef, UploadFileProps>(
  ({ setNomeFile, setContentFile }, ref) => {
    const { showAlert } = UseAlert();
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (!file) {
        showAlert({
          show: true,
          content: "Nenhum arquivo selecionado",
          color: "warning",
          time: 5000
        });
        return;
      }

      const fileName = file.name.toLowerCase();
      const isTxtFile = fileName.endsWith(".txt");

      if (isTxtFile && file.size > MAX_FILE_SIZE) {
        showAlert({
          show: true,
          content: 'O arquivo excede o tamanho máximo permitido de 130 MB. Gere um arquivo zip e tente novamente.',
          color: 'danger',
          time: 5000
        });
        return;
      }

      setNomeFile(file.name);
      setContentFile(file);
    };

    useImperativeHandle(ref, () => ({
      clearFileInput: () => {
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      }
    }));

    return (
      <Col md={10} sm={12} lg={10} className='m-auto mb-2'>
        <input
          ref={fileInputRef}
          type='file'
          className='form-control'
          id='campoFile'
          onChange={handleFileChange}
        />
      </Col>
    );
  }
);

// Exporta corretamente tipado
export default UploadFile;
